import { render } from "./ComputedWatch.vue?vue&type=template&id=4dbd64f9"
import script from "./ComputedWatch.vue?vue&type=script&lang=ts"
export * from "./ComputedWatch.vue?vue&type=script&lang=ts"
script.render = render

export default script